/**
 * @fileoverview Workflow and record-status badge catalog.
 * @module ui-artwork/catalog/badges
 *
 * Responsibilities: Register the fixed set of stable status badge IDs.
 * Dependencies: ArtworkCatalogEntry.
 * Architecture: Static metadata; runtime workflow animation is resolved separately.
 * Notes: A static progress badge does not activate its workflow halo.
 */
import type { ArtworkCatalogEntry } from '../types';

const badge = (id: string, label: string, color: string, keywords: string[]): ArtworkCatalogEntry => ({
  id: `art:badge/${id}`,
  label,
  category: 'status',
  style: 'badge',
  keywords: [label.toLowerCase(), ...keywords],
  colorPolicy: 'customizable',
  defaultColor: color,
  source: 'firesight-badge',
});

export const BADGE_ARTWORK: ArtworkCatalogEntry[] = [
  badge('progress-active', 'Active progress', '#7c3aed', ['active', 'progress', 'live']),
  badge('status-scheduled', 'Scheduled', '#3b82f6', ['scheduled', 'calendar']),
  badge('status-paused', 'Paused', '#475569', ['paused', 'in progress']),
  badge('status-completed', 'Completed', '#16a34a', ['completed', 'check']),
  badge('status-overdue', 'Overdue', '#dc2626', ['overdue', 'late']),
  badge('status-violation', 'Open violation', '#b91c1c', ['violation', 'alert']),
  badge('status-other-account', 'Other account activity', '#7c3aed', ['account', 'activity']),
];
